module.exports = __webpack_public_path__ + "img/patient-avatar-placeholder.42c1961c.svg";